import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import { withRouter } from "react-router-dom";
import FileUploader from "react-firebase-file-uploader";
import { getlanguagelist } from "../../../helpers/changelanguage";
import { registerVersion } from 'firebase';
import $$ from 'jquery';
import firebase from '../../../../src/config';
import { saveChat,deleteChat,updateReadChat} from "../../../actions/chatAction";
import moment from 'moment';
import Modal from "react-responsive-modal";
import Giffy2 from "../../ChatContainer/ChatBody/Giffy2";
import { confirmAlert } from 'react-confirm-alert';
import {ToastsStore} from 'react-toasts';
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import Linkify from 'react-linkify';

import './ChatBox.css';


class ChatBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            persons         : [],
            chatPersons     : [],
            chatlist        : [],
            current_user    : '',
            message         : '',
            avatarURL       : '',
            media_type      : 'text',
            giffyOpen       : false,
            uploadSpinner   : false,
            chat_node       : '0',
            visibility      : 'hidden',
            delindex        : null
        };

        this.createChat             = this.createChat.bind(this);
        this.getChatNotification    = this.getChatNotification.bind(this);
        this.minimizeChatList       = this.minimizeChatList.bind(this);
        this.closeChatList          = this.closeChatList.bind(this);
        this.openGiffy              = this.openGiffy.bind(this);
        this.removeImage            = this.removeImage.bind(this);
        this.selectGif              = this.selectGif.bind(this);
        this.openApp                = this.openApp.bind(this);
        // this.handleUploadStart      = this.handleUploadStart.bind(this);
        // this.handleUploadError      = this.handleUploadError.bind(this);
        // this.handleUploadSuccess    = this.handleUploadSuccess.bind(this);
        // this.handleProgress         = this.handleProgress.bind(this);
        this.chk_scroll             = this.chk_scroll.bind(this);
        this.delChat                = this.delChat.bind(this);
        this.onTextMouseOver        = this.onTextMouseOver.bind(this);
        this.onCustomImageUpload    = this.onCustomImageUpload.bind(this);
        this.uploadFile             = this.uploadFile.bind(this);
    };

    onTextMouseOver(index){
        $$('#text_msg_'+index).children('a').attr('target', '_blank');
    }

    chk_scroll(e){
        var elem = $(e.currentTarget);
        //console.log('2.scrollHeight :: ', $$('#msg_history').prop("scrollHeight"));
        //console.log('2.outerHeight :: ', $$('#msg_history').outerHeight());
        if (elem[0].scrollHeight - elem.scrollTop() == elem.outerHeight())
        {  
            this.setState({
                visibility : 'visible'
           });
        }
    } 

    delChat(index,timestamp){
        let languagelist = getlanguagelist();
        let param = {
            firebase_timestamp : timestamp,
            receiver_id        : this.state.current_user
        }

        confirmAlert({
            title: languagelist.cofirm,
            message: languagelist.sure,
            buttons: [
              {
                label: languagelist.yes,
                onClick: () => {
                    this.setState({
                        delindex : index
                    },function(){
                        this.props.deleteChat(param);
                    })
                }
              },
              {
                label: languagelist.no,
                onClick: () => {
                    return false;
                }
              }
            ]
          });
    }

    componentDidMount() {    
        this.getChatNotification();
    }

    handleChange(event) {
        this.setState({message: event.target.value});
    }

    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
        
        if(this.props.chatPersons != nextProps.chatPersons){
            //pageloader(true);
            let chatPerson = [];
            chatPerson = nextProps.chatPersons;
            let chaticon = this.state.persons;
            
            if(chatPerson['user_id']!=='' && chatPerson['user_id']!== undefined){
                if(chaticon.some(person => person.user_id === chatPerson['user_id'])){
                    //Already exist person
                    this.getChatlist(chatPerson);
                }
                else
                {
                    let chaticonLen = chaticon.length;
                    let activeChatIndex;
                    
                    if(chaticonLen>4){
                        let personindex = chaticon.findIndex(data => data.status === '0');
                        console.log(personindex);
                        if(personindex !== -1){
                            chaticon.splice(personindex, 1);
                        }
                    }
                    
                    chaticon.push(chatPerson);
                    this.setState({
                        persons   : chaticon
                    })
                    this.getChatlist(chatPerson);
                }
            }
        } 
        
        if(this.props.displayChatList!= nextProps.displayChatList){
            
            if(nextProps.displayChatList === true)
                this.minimizeChatList();
        }

        if(nextProps.deletechat != this.props.deletechat){
            if(nextProps.deletechat.res == 1){
                this.messageRef.child(this.state.list_key[this.state.delindex]).update({
                    delete_status : true,
                });
            }else{
                ToastsStore.error('Message cannot be deleted')
            }
        }

        if(nextProps.readchat2 != this.props.readchat2){
            console.log('read chat');
        }
    }

    getChatNotification(){
        if(firebase.messaging.isSupported()) {
         const messaging = firebase.messaging();
         messaging.onMessage((payload) => {
            if(payload.data.Room==='Chat Push'){
                let chaticon = this.state.persons;
                
                if(chaticon.some(person => person.user_id === payload.data.link)){
                    
                }else{

                    let chaticonLen = chaticon.length;
                    let activeChatIndex;
                    console.log('Len : ', chaticonLen);
                    if(chaticonLen>4){
                        let personindex = chaticon.findIndex(data => data.status === '0');
                        console.log(personindex);
                        if(personindex !== -1){
                            chaticon.splice(personindex, 1);
                        }
                        console.log('chaticon : ',chaticon);
                    }

                    let add         = [];
                    add.user_id     = payload.data.link;
                    add.name        = payload.data.body;
                    add.image       = payload.data.icon;
                    add.status      = '0';

                    chaticon.push(add);

                    this.setState({
                        persons   : chaticon
                    })

                    console.log('Person',this.state.persons);
                }
            }
        }); 
      }
    }

    getChatlist(row){
        
        //console.log(parseInt(this.props.me.id));
        // this.setState({
        //     visibility : 'hidden'
        // }); 
        this.minimizeChatList();
        this.props.closeAllChatList(false);

        let list            = this.state.chatlist;
        let chatPerson      = this.state.persons;

        let me              = parseInt(this.props.me.id);
        let myfriend        = parseInt(row['user_id']);
        let chatcombination = (me > myfriend) ? `${myfriend}_${me}` : `${me}_${myfriend}`;
        let msgList         = [];
        let list_key        = [];
        let is_new          = false;


        const userdetails  = sessionStorage.getItem('userDetails') || localStorage.getItem('userDetails');
        let userdetailsArr = JSON.parse(userdetails);
        firebase.auth().signInWithCustomToken(userdetailsArr.firebase_auth_token)
        .then((userCredential) => {
            this.messageRef     = firebase.database().ref().child('MsgCovrsn').child(chatcombination).child('msg');
            this.messageRef
                    .on('value', message => {
                //console.log(Object.values(message.val()));

                msgList         = (message.val() != null) ? Object.values(message.val()) : [];
                is_new          = (message.val() != null) ? true : false;
                list_key        = (message.val() != null) ? Object.keys(message.val()) : [];

                //console.log('=== ', list.some(data => data.user_id === row['user_id']));
                if(list.some(data => data.user_id === row['user_id']))
                {
                    let index = list.findIndex(data => data.user_id ===row['user_id']);
                    list[index].msgList = msgList
                    list[index].is_new  = is_new;

                    if(chatPerson.some(data => data.user_id === row['user_id'])){
                        let personindex = chatPerson.findIndex(data => data.user_id ===row['user_id']);
                        chatPerson[personindex].status = '1';
                    }
                }
                else
                {
                    let add         = [];
                    add.user_id     = row['user_id'];
                    add.name        = row['name'];
                    add.image       = row['image'];
                    add.display     = 1;
                    add.msgList     = msgList;
                    add.is_new      = is_new;
                    //list.push(add);
                    list[0] = add;

                    if(chatPerson.some(data => data.user_id === row['user_id'])){
                        let personindex = chatPerson.findIndex(data => data.user_id ===row['user_id']);
                        chatPerson[personindex].status = '1';
                    }
                }
                this.setState({
                    chatlist        : list,
                    current_user    : row['user_id'],
                    list_key        : list_key,
                    persons         : chatPerson,
                    chat_node       : chatcombination
                },function(){
                    //console.log('New');
                    this.props.updateReadChat({sender_id:row['user_id'],timestamp:Math.floor(Date.now() / 1000)});
                    if( $$('#msg_history').prop("scrollHeight") == $$('#msg_history').outerHeight()){
                        this.setState({
                            visibility : 'visible'
                        });
                    }else{
                        $$("#msg_history").animate({ scrollTop: $$('#msg_history').prop("scrollHeight")});
                    }
                })
            })
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log(errorMessage);
          ToastsStore.error(errorMessage);
          // ...
        }); 
    }

    handleSend(row) {
        console.log('user ', this.state.user_id);
        

        if (this.state.message!= '' || this.state.avatarURL!= '') {
            let me              = parseInt(this.props.me.id); 
            let myfriend        = parseInt(row.user_id);
            let chatcombination = (me > myfriend) ? `${myfriend}_${me}` : `${me}_${myfriend}`;
            //console.log(chatcombination);

            const userdetails  = sessionStorage.getItem('userDetails') || localStorage.getItem('userDetails');
            let userdetailsArr = JSON.parse(userdetails);
            firebase.auth().signInWithCustomToken(userdetailsArr.firebase_auth_token)
            .then((userCredential) => {
                this.messageRef     = firebase.database().ref().child('MsgCovrsn').child(chatcombination).child('msg');
                this.messageRef2    = firebase.database().ref().child('MsgCovrsn').child(chatcombination);  
            
            

                    var newItem = {
                        content       : {text: this.state.message, 
                                        type: this.state.media_type, 
                                        url: this.state.avatarURL, 
                                        videoThumbUrl: this.state.avatarURL},
                        delete_status : false,
                        senderId      : this.props.me.id,
                        timestamp     : Math.floor(Date.now()/ 1000).toString()
                    }
                    
                    if(row.is_new == false){   
                        this.messageRef2.set( {
                            [`${this.props.me.id}_isTyping`] : false,
                            [`${this.props.me.id}_timestamp`] : Math.floor(Date.now() / 1000),
                            [`${myfriend}_isTyping`] : false,
                            [`${myfriend}_timestamp`] : Math.floor(Date.now() / 1000),
                            msg                          : null
                            
                        });
                        this.messageRef.push(newItem);
                    
                    }else{
                        this.messageRef2.update( {
                            [`${this.props.me.id}_isTyping`] : false,
                            [`${this.props.me.id}_timestamp`] : Math.floor(Date.now() / 1000),
                            [`${row.user_id}_isTyping`] : false,
                            [`${row.user_id}_timestamp`] : Math.floor(Date.now() / 1000),
                            
                        });
                        this.messageRef.push(newItem);
                    }
                    this.createChat(newItem.timestamp);
                    this.setState({ message: '' , avatarURL : ''})
            })        
            .catch((error) => {
                var errorCode = error.code;
                var errorMessage = error.message;
                console.log(errorMessage);
                ToastsStore.error(errorMessage);
                // ...
            }); 
        }
    }

    createChat(firebase_timestamp){
       // this.props.updateReadChat({sender_id:this.state.current_user,timestamp:Math.floor(Date.now() / 1000)});
        let param = {
            receiver_id         : this.state.current_user,
            message             : this.state.message,
            date_time           : (moment().format('YYYY-MM-DD HH:mm:ss')),
            media_link          : this.state.avatarURL,
            media_type          : this.state.media_type.toUpperCase(),
            firebase_timestamp  : firebase_timestamp
        };
        console.log('param ', param);
        this.props.saveChat(param);
    }

    minimizeChatList(){
        let current_user = this.state.current_user;
        let chatPerson   = this.state.persons;

        if(chatPerson.some(data => data.user_id === current_user)){
            let personindex = chatPerson.findIndex(data => data.user_id === current_user);
            chatPerson[personindex].status = '0';
        }

        let list = [];
        this.setState({
            chatlist     : list,
            current_user : '',
            persons      : chatPerson,
            chat_node    : '0'
        })
        console.log('chatpersons ',this.state.persons);
    }

    closeChatList(){
        let current_user = this.state.current_user;
        let chatPerson   = this.state.persons;

        if(chatPerson.some(data => data.user_id === current_user)){
            let personindex = chatPerson.findIndex(data => data.user_id === current_user);
            if(personindex !== -1){
                chatPerson.splice(personindex, 1);
            }
        }

        let list = [];
        this.setState({
            chatlist     : list,
            current_user : '',
            persons      : chatPerson,
            chat_node    : '0'
        })
    }

    openApp(){
        $("#appModal").modal('show');
    }

    openGiffy(){
        this.setState({
            giffyOpen : (this.state.giffyOpen == true) ? false : true
        }) 
    }

    selectGif(gifurl){
        this.setState({
            avatarURL  : gifurl,
            media_type : 'gif',
            giffyOpen  : false
        });
    }

    removeImage(){
        this.setState({ avatarURL: '' });

    }
    
    onCustomImageUpload(e){
        
        let  languagelist = getlanguagelist();

        let file = e.target.files[0];
        
        if(file.type.includes("image")){
            let sizeInMB = (e.target.files[0].size / (1024*1024)).toFixed(2);
            if(sizeInMB > 2){
                ToastsStore.error(languagelist.validimage);
            }else{
                this.uploadFile(file);
            }
        }else{
            
            var video = document.createElement('video');
            video.preload = 'metadata';
            var obj = this;
            video.onloadedmetadata = function() {
                window.URL.revokeObjectURL(video.src);
                if (video.duration > 120) {
                    ToastsStore.error(languagelist.validvedio);
                }else{
                    obj.uploadFile(file);
                }
                //obj.preview(file);
            }
            video.src = URL.createObjectURL(file);          
        }

    }

    uploadFile(file){
        this.setState({ uploadSpinner: true});

        let today = new Date();
        let date = today.getFullYear()+''+(today.getMonth()+1)+''+today.getDate();
        let time = today.getHours()+''+today.getMinutes() +''+ today.getSeconds();
        let datetime = date+''+time;

        let filename = file.name;
        let filenameArr = filename.split('.');
        let name_len = filenameArr.length;
        let newfileName = 'chat'+datetime+'.'+filenameArr[name_len-1];
        
        filename = newfileName;

        if(filename.includes('JPG') == true || filename.includes('PNG') == true || filename.includes('JPEG') == true || filename.includes('png') == true || filename.includes('jpg') == true){
            this.setState({
                media_type  : 'image'
            })
        }
        if(filename.includes('mp4') == true || filename.includes('m4v') == true){
            this.setState({
                media_type  : 'video'
            })
        }
        if(filename.includes('mp3') == true){
            this.setState({
                media_type  : 'audio'
            })
        }
       
        this.setState({ avatar: filename, progress: 100, isUploading: false });
        const storage       =   firebase.storage();
        const uploadTask    =   storage.ref(this.state.chat_node+'/'+filename).put(file);
        uploadTask.on(
            "state_changed",
            snapshot => {
              // progress function ...
              const progress = Math.round(
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              );
              console.log('progress :: ',progress);
              this.setState({ progress });
            },
            error => {
              // Error function ...
              console.log('error :: ',error);
            },
            () => {
              // complete function ...
                storage
                    .ref(this.state.chat_node)
                    .child(filename)
                    .getDownloadURL()
                    .then(url => {
                        this.setState({ avatarURL: url, uploadSpinner : false});
                    });
            }
        );
    }

    render() {
        let  languagelist = getlanguagelist();
        let devider_date = '';
        let show  = 'YES';

        let options = {
            buttons: {
                backgroundColor: 'rgba(30,30,36,0.8)',
                iconColor: 'rgba(255, 255, 255, 0.8)',
                iconPadding: '5px',
                showAutoplayButton: false,
                showCloseButton: true,
                showDownloadButton: false,
                showFullscreenButton: true,
                showNextButton: true,
                showPrevButton: true,
                showThumbnailsButton: false,
                size: '40px'
            }
        };

        return (
            <div>
                {
                
                    (this.state.persons).map((row,index) => {
                        const count = (index+1);
                        const width = 90;
                        const rightsize = (120+(width*count));
                        const divStyle = {
                                right: rightsize+'px'
                            };
                            
                        return (
                            
                            <div  className="fixed-action-btn-profile" key={index} style={divStyle} onClick={this.getChatlist.bind(this, row)}> 
                                <a className="btn-floating-profile"> <img src={row.image} width="100%" title={row.name} /> </a> 
                            </div>
                        )
                    })
                }

                {
                    (this.state.chatlist).map((row,index) => {
                        const count = (index+1);
                        const rightsize = 140*count;
                        const divStyle2 = {
                                right: rightsize+'px',
                                position : 'fixed',
                                display :  row.display === 1 ? 'block' : 'none'
                            };
                        return (
                            <div className="chat-box" key={index} style={divStyle2} >
                                <div className="chat-header"> 
                                    <div className="chat-header-profile-image">
                                        <img src={row.image} />
                                    </div>
                                    <h4>{row.name}</h4>
                                    <a href="#" onClick={this.closeChatList} className="chat-close">X</a>
                                    <a href="#" onClick={this.minimizeChatList} className="chat-minimize">-</a>
                                </div>
                                
                                <SimpleReactLightbox>
                                    <div className="chat-wrapper" id="msg_history">
                                        <SRLWrapper options={options}>

                                        {
                                            (row.msgList).map((item,newindex) =>{
                                                if(devider_date != (moment(item.timestamp * 1000).format('DD/MM/YYYY'))){
                                                    show = 'YES';
                                                    devider_date = (moment(item.timestamp * 1000).format('DD/MM/YYYY'))
                                                }else{
                                                    show = 'NO';
                                                }
                                                if((item.delete_status == false) || (item.delete_status == 'false')){    
                                                    return (                                     
                                                        <div key={`chat_${newindex}`}>
                                                            {
                                                                (item.senderId == this.props.me.id)?
                                                                    <div>
                                                                        {
                                                                            (show == 'YES') ? 
                                                                                <div className="date-nd">
                                                                                    <span>{devider_date}</span>
                                                                                </div>
                                                                            :
                                                                                null
                                                                        }
                                                                        <div className="chat-left-content">
                                                                            {(item.content.type == 'image') ?
                                                                        
                                                                                <p>
                                                                                    <a href={item.content.url} data-attribute="SRL">
                                                                                        <img src={item.content.url} />
                                                                                    </a>
                                                                                </p>
                                                                                
                                                                                : null
                                                                            }

                                                                            {(item.content.type == 'gif') ?
                                                                        
                                                                                <p>
                                                                                    <a href={item.content.url} data-attribute="SRL">
                                                                                        <img src={item.content.url}/>
                                                                                    </a>
                                                                                </p>
                                                                                
                                                                                : null
                                                                            }

                                                                            {(item.content.type == 'video') ?
                                                                                
                                                                                <p>
                                                                                    <video controls controlsList="download" style={{width : '100%'}}>
                                                                                        <source src={item.content.url} type="video/mp4" />
                                                                                        Your browser does not support the video tag.
                                                                                    </video>
                                                                                </p>
                                                                                    
                                                                                : null
                                                                            }

                                                                            {(item.content.type == 'audio') ?
                                                                                
                                                                                <p>
                                                                                    <audio controls style={{width : '100%'}}>
                                                                                        <source src={item.content.url} type="audio/mp3" />
                                                                                    </audio>
                                                                                </p>
                                                                                
                                                                                : null
                                                                            }

                                                                            {(item.content.text != '') ?
                                                                                <p id={`text_msg_${newindex}`} onMouseOver={() => this.onTextMouseOver(newindex)}> 
                                                                                    <Linkify>{item.content.text}</Linkify>
                                                                                </p>
                                                                                :
                                                                                null
                                                                            }
                                                                            <span className="chat-delete" onClick={()=>this.delChat(newindex,item.timestamp)}>
                                                                                <img className="chat-del-icon" src="/assets/images/dl-ico.png" width="40" />
                                                                            </span>
                                                                        </div>
                                                                        <span className="small-date">{(moment(item.timestamp * 1000).format('hh:mm a'))}</span>
                                                                    </div>
                                                                :
                                                                    <div>
                                                                        {
                                                                            (show == 'YES') ? 
                                                                                <div className="date-nd">
                                                                                    <span>{devider_date}</span>
                                                                                </div>
                                                                            :
                                                                                null
                                                                        }
                                                                        <div className="chat-right-content">
                                                                            {(item.content.type == 'image') ?
                                                                        
                                                                                <p>
                                                                                    <a href={item.content.url} data-attribute="SRL"><img src={item.content.url} /></a>
                                                                                </p>
                                                                                
                                                                                : null
                                                                            }

                                                                            {(item.content.type == 'gif') ?
                                                                        
                                                                                <p>
                                                                                    <a href={item.content.url} data-attribute="SRL">
                                                                                        <img src={item.content.url}/>
                                                                                    </a>
                                                                                </p>
                                                                                
                                                                                : null
                                                                            }

                                                                            {(item.content.type == 'video') ?
                                                                                
                                                                                <p>
                                                                                    <video controls controlsList="download" style={{width : '100%'}}>
                                                                                        <source src={item.content.url} type="video/mp4" />
                                                                                        Your browser does not support the video tag.
                                                                                    </video>
                                                                                </p>
                                                                                    
                                                                                : null
                                                                            }

                                                                            {(item.content.type == 'audio') ?
                                                                                
                                                                                <p>
                                                                                    <audio controls style={{width : '100%'}}>
                                                                                        <source src={item.content.url} type="audio/mp3" />
                                                                                    </audio>
                                                                                </p>
                                                                                
                                                                                : null
                                                                            }

                                                                            {(item.content.text != '') ?
                                                                                <p id={`text_msg_${newindex}`} onMouseOver={() => this.onTextMouseOver(newindex)}>
                                                                                    <Linkify>{item.content.text}</Linkify>
                                                                                </p>
                                                                                :
                                                                                null
                                                                            }
                                                                            
                                                                        </div>

                                                                        <span className="small-date">{(moment(item.timestamp * 1000).format('hh:mm a'))}</span>
                                                                    </div>
                                                                
                                                            }
                                                        </div>
                                                    )
                                                }
                                            })
                                            
                                        }
                                        </SRLWrapper>
                                    </div>
                                </SimpleReactLightbox>

                                <div className="chat-footer">

                                    <Modal open={this.state.giffyOpen} onClose={this.openGiffy} showCloseIcon={false} center>
                                        <Giffy2 
                                        selectGif = {this.selectGif}
                                        opengiffy = {this.openGiffy}
                                        />
                                    </Modal>

                                    {
                                    (this.state.avatarURL != '') ? 
                                        <div className="preview_attach">
                                            <ul>
                                                <li>
                                                    <a href={void(0)} className="close"  onClick={this.removeImage}>
                                                        <i className="fa fa-times-circle" aria-hidden="true"></i>
                                                    </a>
                                                    { (this.state.media_type == 'image') ?
                                                        <img className="" src={this.state.avatarURL} />
                                                        : null
                                                    }
                                                    { (this.state.media_type == 'gif') ?
                                                        <img className="" src={this.state.avatarURL} />
                                                        : null
                                                    }
                                                    { (this.state.media_type == 'video') ?
                                                        <video controls className="chat_media" controlsList="nodownload">
                                                            <source src={this.state.avatarURL} type="video/mp4" />
                                                            Your browser does not support the video tag.
                                                        </video> 
                                                        : null
                                                    }
                                                    { (this.state.media_type == 'audio') ?
                                                        <audio controls >
                                                            <source src={this.state.avatarURL} type="audio/mp3" />
                                                        </audio>
                                                        : null
                                                    }
                                                </li>
                                                
                                            </ul>


                                            <div className="clearfix"></div>
                                        </div>
                                    : 
                                        null 
                                    }

                                    <textarea type="text" 
                                    placeholder={languagelist.message1} 
                                    onChange={this.handleChange.bind(this)}
                                    value = {this.state.message} 
                                    rows="4"></textarea>
                                    {/* <button type="submit">Go</button> */}
                                    
                                    <button type="button" onClick={this.handleSend.bind(this,row)}><i className="far fa-paper-plane"></i></button>

                                    <div className="custom-file">
                                        {
                                            (this.state.uploadSpinner == true) ? 
                                            <i className='fa fa-spinner fa-spin'></i> 
                                            : null
                                        }
                                       
                                        
                                            
                                                                          
                                    </div>
                                    <ul className="ft-options">
                                        <li>
                                            <label>
                                                <i className="fa fa-paperclip"></i>
                                                <FileUploader 
                                                    accept="image/*,video/*"
                                                    name="avatar"
                                                    randomizeFilename
                                                    storageRef={firebase.storage().ref(this.state.chat_node)}
                                                    onChange={this.onCustomImageUpload}
                                                    className="custom-file-input" 
                                                    hidden
                                                /> 
                                            </label>
                                        </li>

                                        <li>
                                            <a href="#" onClick={this.openGiffy}><i className="fa fa-smile-o"></i></a>
                                        </li>
                                        <li>
                                            <a href="#" onClick={this.openApp}><i className="fa fa-phone"></i></a>
                                        </li>
                                        <li>
                                            <a href="#" onClick={this.openApp}><i className="fa fa-video-camera"></i></a>
                                        </li>
                                    </ul>
                                </div>
                                
                                
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        me         : state.login.user,
        savechat   : state.createchat.createChat,
        deletechat : state.removechat.removeChat,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        deleteChat       : bindActionCreators(deleteChat, dispatch),
        saveChat         : bindActionCreators(saveChat, dispatch),
        updateReadChat   : bindActionCreators(updateReadChat, dispatch),
    }
  }

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ChatBox));
//export default ChatBox;